import { CategoryFilterType } from 'b2b-apps/shop/product/hooks';
import { ComparedProduct } from 'b2b-common/core/product/api/ProductsCompare.types';

export const getCategoriesFiltersFromComparisonItems = (
  products: ComparedProduct[],
  allFiltersLabel: string,
): CategoryFilterType[] | null => {
  const filters: ({ value: string, count: number })[] = [];

  [...products]
    .forEach(product => {
      const categoryName = product.details.categoryName;
      const filter = filters.find(filter => filter.value === categoryName);

      if (filter) {
        filter.count++;
      } else {
        filters.push({ value: categoryName, count: 1 });
      }
    });

  if (filters.length <= 1) {
    return null;
  }

  return [
    { value: allFiltersLabel, count: products.length, label: `${allFiltersLabel} (${products.length})` },
    ...filters
      .sort((firstFilter, secondFilter) => secondFilter.count - firstFilter.count)
      .map(filter => ({
        value: filter.value,
        count: filter.count,
        label: `${filter.value} (${filter.count})`,
      })),
  ];
};
